import Vue from 'vue';
import Router from 'vue-router';

import RouteView from '../components/route-view.vue';

import Login from '../components/login/login.vue';
import Home from '../components/home/home.vue';
import Orders from '../components/orders/orders.vue';
import walletRecord from '../components/walletRecord/index.vue';
import merchantInfo from '../components/merchantInfo';
import withdrawBank from '../components/withdrawBank/index.vue';
import withdraw from '../components/withdraw/index.vue';
import merchantdeposit from '../components/merchantdeposit/index.vue';
import safeCenter from '@/components/safe-center';
import merchantBehalf from '../components/payout/orders';
import balanceHistory from '../components/balance-history';
import usdtAccount from '../components/usdt/account';
import usdtWithdrawList from '../components/usdt/withdrawlist';
import usdtOrderManage from '../components/usdt/index';
import usdtWithdrwa from '../components/usdt/withdrwa';
import subAccount from '../components/childrenlist/index.vue';
import C404 from '@/components/404';
import Welcomes from '@/components/welcomes/index.vue';

class MyRouter extends Router {
  push(location) {
    console.log('🚀 ~ file: index.js ~ line 27 ~ MyRouter ~ push ~ location', location);
    return super.push.call(this, location).catch((err) => err);
  }
}
Vue.use(MyRouter);

const asyncRouterMap = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/welcomes',
    children: [
      //没有权限时进入 welcomes页面
      {
        path: '/welcomes',
        name: 'welcomes',
        component: Welcomes,
        children: []
      },
      //仪表盘
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/workplace',
        component: RouteView,
        meta: { permission: ['dashboard:manager'] },
        children: [
          {
            path: '/dashboard/workplace',
            name: 'Workplace',
            component: () => import('@/components/dashboard/index.vue'),
            meta: { permission: ['workplace:manager'] }
          }
        ]
      },
      // merchant
      {
        path: '/merchant',
        name: 'merchant',
        redirect: '/merchant/orders',
        component: RouteView,
        meta: { permission: ['merchant:manager'] },
        children: [
          {
            path: '/merchant/subAccount/list/page',
            name: 'subAccount',
            component: subAccount,
            meta: { permission: ['merchant:subAccount:list:page'] }
          },
          {
            path: '/merchant/withdrawBank',
            name: 'withdrawBank',
            component: withdrawBank,
            meta: { permission: ['withdrawBank:manager'] }
          },
          {
            path: '/merchant/merchantInfo',
            name: 'merchantInfo',
            component: merchantInfo,
            meta: {
              permission: ['merchantInfo']
              //  isKeepAlive: true
            }
          },
          {
            path: '/merchant/safeCenter',
            name: 'safeCenter',
            component: safeCenter,
            meta: { permission: ['securitycenter'] }
          },
          {
            path: '/merchant/payout/orders',
            name: 'merchantBehalf',
            component: merchantBehalf,
            meta: { permission: ['merchant:payout:orders'] }
          },
          {
            path: '/merchant/withdraw',
            name: 'merchantWithdraw',
            component: withdraw,
            meta: { permission: ['withdraw:manager'] }
          },
          {
            path: '/merchant/merchantdeposit',
            name: 'merchantdeposit',
            component: merchantdeposit,
            meta: { permission: ['merchant:deposit'] }
          },

          {
            path: '/merchant/orders',
            name: 'Orders',
            component: Orders,
            meta: { permission: ['merchant:order'] }
          },
          {
            path: '/merchant/walletRecord',
            name: 'walletRecord',
            component: walletRecord,
            meta: { permission: ['system:walletRecord'] }
          },
          {
            path: '/merchant/balance/page',
            name: 'MerchantBalanceHis',
            component: balanceHistory,
            meta: { permission: ['merchant:balance:list'] }
          },
          {
            path: '/merchant/usdt/account/list/page',
            name: 'USDTAccount',
            component: usdtAccount,
            meta: { permission: ['merchant:usdt:account:list:page'] }
          },
          {
            path: '/merchant/usdt/withdraw/list',
            name: 'WithdrawList',
            component: usdtWithdrawList,
            meta: { permission: ['withdraw:usdt:list:page'] }
          },
          {
            path: '/merchant/usdt/list/page',
            name: 'USDTOrderManage',
            component: usdtOrderManage,
            meta: { permission: ['merchant:usdt:lis:page'] }
          },
          {
            path: '/merchant/usdt/withdraw',
            name: 'USDTWithdraw',
            component: usdtWithdrwa,
            meta: { permission: ['merchant:usdt:withdraw'] }
          }
        ]
      }
    ]
  },
  {
    path: '*',
    redirect: '/welcomes',
    hidden: true
  }
];
const constantRouterMap = [
  {
    name: 'user',
    path: '/user',
    redirect: '/user/login',
    component: RouteView,
    children: [
      {
        name: 'login',
        path: '/user/login',
        component: Login
      }
    ]
  }

  // {
  //   path: '/welcomes',
  //   component: C404
  // }
];

const router = new MyRouter({
  mode: 'history',
  routes: constantRouterMap
  // routes: asyncRouterMap
});

export { router as default, asyncRouterMap, constantRouterMap };



// WEBPACK FOOTER //
// ./src/router/index.js